import { createAsyncThunk } from '@reduxjs/toolkit';
import loadStructure from './loadStructure';
import { TAsyncThunkState } from '../../../types';
import { TResponsiveTableSortChangeEvent } from '../../../../../components/common/generic/responsiveTable/types';
import {
  TApiaFunctionPageInfo,
  TApiaRowDefinition,
} from '../../../../../types';
import store from '../../../..';
import { responsiveTableActions } from '../../../../responsiveTableSlice';
import { getCurrentListId } from '../../../../../components/apia/common/lists/hooks/useCurrentListId';
import setFilters from './setFilters';
import updateData from './updateData';
import { validateDateFilters } from './search';
import { notify } from '../../../../../components/common/notifications/util';
import { TQueriesActionsChain } from '../../../queueController';

type TSort = {
  fieldId: string;
  query?: Record<string, unknown>;
  sortValue: TResponsiveTableSortChangeEvent;
  ignoreSetFilters?: boolean;
  queueKey?: TQueriesActionsChain;
};

const sort = createAsyncThunk<
  null | {
    pageInfo?: TApiaFunctionPageInfo;
    table?: TApiaRowDefinition[];
    columnIndex: number;
  },
  TSort,
  TAsyncThunkState
>(
  'querySlice/sorter',
  async ({ fieldId, sortValue, query, ignoreSetFilters }, thunkApi) => {
    const state = thunkApi.getState().querySlice.queries[fieldId];
    store.dispatch(
      responsiveTableActions.update({
        tableName: getCurrentListId(),
        selectedRows: [],
      }),
    );

    const areDatesValid = validateDateFilters(state.filters ?? []);
    if (!areDatesValid) {
      notify({
        message: window.MSG_FEC_FIN_MAY_FEC_INI,
        type: 'warning',
      });
      return null;
    }
    if (!ignoreSetFilters) {
      await store.dispatch(
        setFilters({
          fieldId,
          queueKey: 'fromSort',
        }),
      );
    }

    await store.dispatch(
      loadStructure({
        fieldId,
        action: 'sort',
        query: {
          orderBy: sortValue.name.toUpperCase(),
          orderJustThisColumn: 'true',
          ...query,
        },
        queueKey: 'fromSort',
      }),
    );

    await store.dispatch(
      updateData({
        fieldId,
        requestConfig: {
          queryData: query,
        },
        queueKey: 'fromSort',
      }),
    );
    return null;
  },
);

export default sort;
